var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderTopRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.7002C8.01869 10.7002 8.03335 10.6855 8.03335 10.6668C8.03335 10.6482 8.01869 10.6335 8.00002 10.6335C7.98135 10.6335 7.96669 10.6482 7.96669 10.6668C7.96669 10.6855 7.98135 10.7002 8.00002 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 5.36667C8.01869 5.36667 8.03335 5.352 8.03335 5.33333C8.03335 5.31467 8.01869 5.3 8.00002 5.3C7.98135 5.3 7.96669 5.31467 7.96669 5.33333C7.96669 5.352 7.98135 5.36667 8.00002 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 8.03341C8.01869 8.03341 8.03335 8.01875 8.03335 8.00008C8.03335 7.98141 8.01869 7.96675 8.00002 7.96675C7.98135 7.96675 7.96669 7.98141 7.96669 8.00008C7.96669 8.01875 7.98135 8.03341 8.00002 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 8.00008C5.3 8.01875 5.31467 8.03341 5.33333 8.03341C5.352 8.03341 5.36667 8.01875 5.36667 8.00008C5.36667 7.98141 5.352 7.96675 5.33333 7.96675C5.31467 7.96675 5.3 7.98141 5.3 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 8.03341C2.68531 8.03341 2.69998 8.01875 2.69998 8.00008C2.69998 7.98141 2.68531 7.96675 2.66665 7.96675C2.64798 7.96675 2.63331 7.98141 2.63331 8.00008C2.63331 8.01875 2.64798 8.03341 2.66665 8.03341",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6333 8.00008C10.6333 8.01875 10.648 8.03341 10.6666 8.03341C10.6853 8.03341 10.7 8.01875 10.7 8.00008C10.7 7.98141 10.6853 7.96675 10.6666 7.96675C10.648 7.96675 10.6333 7.98141 10.6333 8.00008",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 10.7002C2.68531 10.7002 2.69998 10.6855 2.69998 10.6668C2.69998 10.6482 2.68531 10.6335 2.66665 10.6335C2.64798 10.6335 2.63331 10.6482 2.63331 10.6668C2.63331 10.6855 2.64798 10.7002 2.66665 10.7002",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 5.36667C2.68531 5.36667 2.69998 5.352 2.69998 5.33333C2.69998 5.31467 2.68531 5.3 2.66665 5.3C2.64798 5.3 2.63331 5.31467 2.63331 5.33333C2.63331 5.352 2.64798 5.36667 2.66665 5.36667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 13.3667C8.01869 13.3667 8.03335 13.352 8.03335 13.3333C8.03335 13.3147 8.01869 13.3 8.00002 13.3C7.98135 13.3 7.96669 13.3147 7.96669 13.3333C7.96669 13.352 7.98135 13.3667 8.00002 13.3667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 13.3333C5.3 13.352 5.31467 13.3667 5.33333 13.3667C5.352 13.3667 5.36667 13.352 5.36667 13.3333C5.36667 13.3147 5.352 13.3 5.33333 13.3C5.31467 13.3 5.3 13.3147 5.3 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6333 13.3333C10.6333 13.352 10.648 13.3667 10.6666 13.3667C10.6853 13.3667 10.7 13.352 10.7 13.3333C10.7 13.3147 10.6853 13.3 10.6666 13.3C10.648 13.3 10.6333 13.3147 10.6333 13.3333",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 13.3667C2.68531 13.3667 2.69998 13.352 2.69998 13.3333C2.69998 13.3147 2.68531 13.3 2.66665 13.3C2.64798 13.3 2.63331 13.3147 2.63331 13.3333C2.63331 13.352 2.64798 13.3667 2.66665 13.3667",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 2.66683C5.3 2.6855 5.31467 2.70016 5.33333 2.70016C5.352 2.70016 5.36667 2.6855 5.36667 2.66683C5.36667 2.64816 5.352 2.6335 5.33333 2.6335C5.31467 2.6335 5.3 2.64816 5.3 2.66683",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 2.70016C2.68531 2.70016 2.69998 2.6855 2.69998 2.66683C2.69998 2.64816 2.68531 2.6335 2.66665 2.6335C2.64798 2.6335 2.63331 2.64816 2.63331 2.66683C2.63331 2.6855 2.64798 2.70016 2.66665 2.70016",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.6335C13.3147 10.6335 13.3 10.6482 13.3 10.6668C13.3 10.6855 13.3147 10.7002 13.3333 10.7002C13.352 10.7002 13.3667 10.6855 13.3667 10.6668C13.3667 10.6482 13.352 10.6335 13.3333 10.6335",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3C13.3147 13.3 13.3 13.3147 13.3 13.3333C13.3 13.352 13.3147 13.3667 13.3333 13.3667C13.352 13.3667 13.3667 13.352 13.3667 13.3333C13.3667 13.3147 13.352 13.3 13.3333 13.3",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 8.26675V2.66675",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76001 2.63999H13.36",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderTopRight);
export default ForwardRef;